import { api } from "./configs/axiosConfigs"

export const CategoryAPI = {
    
    getCategories: async (data:any) => {
        const response = await api.get(
            '/category', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getCategoriesByCompany: async (data:any) => {
        const response = await api.get(
            '/category/listByCompany', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getCategoriesDuplicated: async (data:any) => {
        const response = await api.get(
            '/category/listDuplicated', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getReviewData: async (data:any) => {
        const response = await api.get(
            '/category/reviewData', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getCategoriesWithProducts: async (data:any) => {
        const response = await api.get(
            '/category/listWithProducts', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createCategory: async (data: any) => {
        const response = await api.post(
            '/category/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },

    unifyDuplicated: async (data: any) => {
        const response = await api.post(
            '/category/unifyDuplicated', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editCategory: async (idcategory: number, data: any) => {
        const response = await api.patch(
            `/category/${idcategory}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deleteCategory: async (idcategory: number) => {
        const response = await api.delete(
            `/category/${idcategory}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}